import { ECS } from '../state';
import { randomInRange } from '~/helpers/MathUtils';
import sample from 'lodash/sample';
import gsap from 'gsap';
import { getUrlBoolean } from '~/helpers/UrlParam';
import { urls } from '@/config/assets';
import AssetService from '@/services/AssetService';

const debug = getUrlBoolean('debug');

export const Collectibles = () => {
  // useEffect(() => {
  //   clearCollectibles();
  //   addCollectibles(0);
  // }, []);

  return (
    <>
      <ECS.Entities
        in={collectibles}
        children={Collectible}
      />
    </>
  );
};

export const Collectible = (entity) => {
  // console.log('Collectible', entity);
  // const refMesh = useRef(null);
  const refSprite = useRef(null);
  const refAlpha = useRef(null);

  const [isCollided, setIsCollided] = useState(false);

  useFrame(() => {
    if (entity.isCollided && !isCollided) {
      setIsCollided(true);
    }
  });

  useEffect(() => {
    if (!isCollided) return;

    refSprite.current.frame = 1;

    if (entity.animateOut) {
      let tl = gsap.timeline();
      tl.add('start');
      tl.to(entity.three.scale, { x: 2, y: 2 }, 'start');
      tl.to(refAlpha.current, { alpha: 0 }, 'start');
    }

    console.log('PLAY: Collected ', entity.type);
    AssetService.getAsset(`s_collect_${entity.type}`).play();
  }, [isCollided]);

  const [
    //
    t_barley,
    t_poo,
    t_truck,
  ] = useAsset([
    //
    urls.t_barley,
    urls.t_poo,
    urls.t_truck,
  ]);

  const textures = {
    barley: t_barley,
    poo: t_poo,
    truck: t_truck,
  };

  const texture = textures[entity.type];

  const scales = {
    barley: 1,
    poo: 1,
    truck: [1.3, 1.3 / 0.75, 1],
  };

  const offsets = {
    barley: [0, 0, 0],
    poo: [0, 0, 0],
    truck: [0, 0.2, 0],
  };

  const spritePosition = [
    offsets[entity.type][0],
    offsets[entity.type][1] + entity.size[1] * 0.5,
    offsets[entity.type][2] + 0.01,
  ];

  return (
    <ECS.Entity entity={entity}>
      <ECS.Component name="three">
        <group>
          {debug && (
            <group>
              <mesh position={[0, entity.size[1] * 0.5, 0.01]}>
                <planeGeometry args={[entity.size[0], entity.size[1]]} />
                <meshBasicMaterial
                  color="green"
                  transparent
                  opacity={0.5}
                />
              </mesh>
              <mesh position={[0, 0, 0.01]}>
                <sphereGeometry args={[0.05]} />
                <meshBasicMaterial
                  color="green"
                  transparent
                  opacity={0.5}
                />
              </mesh>
            </group>
          )}

          <mesh
            scale={scales[entity.type]}
            position={spritePosition}
          >
            <planeGeometry args={[entity.size[0], entity.size[1]]} />
            <GBufferMaterial transparent>
              <MaterialModuleSpriteAnimated
                ref={refSprite}
                map={texture}
                rows={1}
                cols={2}
                frames={2}
                frame={0}
              />
              <MaterialModuleAlphaTest />
              <MaterialModuleAlpha ref={refAlpha} />
            </GBufferMaterial>
          </mesh>
        </group>
      </ECS.Component>
    </ECS.Entity>
  );
};

export const clearCollectibles = () => {
  ECS.world.remove(collectibles);
};

// export const addCollectibles = (areaIdx) => {
//   const area = beerConfig.areas[areaIdx];

//   let lastX = 0;

//   for (let i = 0; i < area.numCollectibles; i++) {
//     const type = sample(area.collectibles);
//     const size = itemSizes[type];
//     const width = size[0];
//     const height = size[1];

//     lastX += width;
//     lastX += randomInRange(OBSTACLE_GAP_MIN, OBSTACLE_GAP_MAX);

//     addCollectible(lastX, 1.75, width, height, type);
//   }
// };

export const addCollectible = (
  x = 0,
  y = 0,
  width = 1,
  height = 1,
  type = 'barley',
  opts = {}
) => {
  ECS.world.add({
    isCollidable: true,
    isCollectible: true,
    position: { x, y },
    size: [width, height, 1],
    type,
    ...opts,
  });
};
